import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import throttle from 'lodash/throttle';
import styled from 'styled-components';

// Styled Components
import { SmartContainer, Stack, HorizontalStack, StyledGrid } from '../../../styles/Containers';

// Components
import { Autocomplete } from '../../../components/Forms/Autocomplete';
import { StyledB, StyledP } from '../../../styles/StyledHTML';


// Icons
import { Suggestion } from './Suggestion';
import { TagSetToggle } from './TagSetToggle';

export const SearchAssets = ({
    // New
    label,
    value,
    onChange,
    options,



    // OLD
    helperText = null,
    noLabels = false,
    inputLabel = "Search",
    // label,
    helper = null,

    // onChange,
    limit = null,
    defaultCompare = 'AND'
}) => {

    // Setup Component
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');


    // Render AutoComplete Suggestions
    const renderSuggestion = (props, option) => { return (<Suggestion option={option} {...props} />) }

    const setActiveTagsFormat = (arr) => {

        // Make Sure There Are No Duplicates
        const storage = []
        const filtered = arr.filter(item => {
            if (!storage.includes(String(item.id).toLowerCase())) {
                storage.push(String(item.id).toLowerCase());
                return item;
            }
            return false;

        });

        // Clearn Data
        const fullFilters = filtered?.map(item => {
            let t = { ...item }
            if (!t?.name && options?.length > 0) {
                t = options.find(i => i.id == item.id);
            }
            return t;
        })

        // AND OR
        const formatted = { ...value };
        formatted.tags = [...fullFilters]

        onChange(formatted);
    }

    const handleAndOrChange = (k, v) => {

        // const x = { ...value };
        // x[k] = v;

        // onChange(x);
        // Make Sure There Are No Duplicates
        const storage = []
        const filtered = value?.tags.filter(item => {
            if (!storage.includes(String(item.id).toLowerCase())) {
                storage.push(String(item.id).toLowerCase());
                return item;
            }
            return false;

        });

        // Clearn Data
        const fullFilters = filtered?.map(item => {
            let t = { ...item }
            if (!t?.name && options?.length > 0) {
                t = options.find(i => i.id == item.id);
            }
            return t;
        })

        // AND OR
        const formatted = { ...value };
        formatted.tags = [...fullFilters]
        formatted[k] = v;

        onChange(formatted);

    }
    // Tag Difference: Compare active tags with the options available.
    const tagDifference = () => {
        if (!options) return [];
        const tags = options.filter(tag => {
            const exists = value?.tags?.filter(theTag => tag.id === theTag.id).length;
            return !exists;
        })
        return tags;
    }

    const handleAddTag = (tag) => {
        if (!tag) return;
        const exists = value.tags.filter(theTag => tag.id === theTag.id).length;
        if (!exists) setActiveTagsFormat([...value.tags, tag])
    }

    const handleRemoveTag = (tag) => {
        if (!tag) return;
        const tags = value.tags.filter(theTag => tag.id !== theTag.id);
        setActiveTagsFormat([...tags])
    }


    // ------------------------------
    // Render
    // ------------------------------

    const splitTagTyps = (tagsArr, type) => {
        let filteredTags = [];
        tagsArr.map(tag => {
            let t = { ...tag }
            if (!t?.name && options?.length > 0) {
                t = options.find(i => i.id == tag.id);
            }
            if (t?.type === type) filteredTags.push(t);
            return t;

        });
        return filteredTags;
    }

    const renderTags = (obj, type) => {
        const tags = obj?.tags;
        if (!tags) return (<div></div>);

        const genericTags = splitTagTyps(tags, 'tag');
        const people = splitTagTyps(tags, 'person');
        const locations = splitTagTyps(tags, 'location');

        return (
            <StyledGrid width="100%">
                {genericTags?.length > 0 && (<TagSetToggle label="Tags" tags={genericTags} compare={(value?.GenericTagCompare) ? value.GenericTagCompare : defaultCompare} onCompareChange={(v) => handleAndOrChange('GenericTagCompare', v)} onRemoveTag={handleRemoveTag} />)}
                {people?.length > 0 && (<TagSetToggle label="People" tags={people} compare={(value?.PersonCompare) ? value.PersonCompare : defaultCompare} onCompareChange={(v) => handleAndOrChange('PersonCompare', v)} onRemoveTag={handleRemoveTag} />)}
                {locations?.length > 0 && (<TagSetToggle label="Locations" tags={locations} compare={(value?.LocationsCompare) ? value.LocationsCompare : defaultCompare} onCompareChange={(v) => handleAndOrChange('LocationsCompare', v)} onRemoveTag={handleRemoveTag} />)}
            </StyledGrid>
        )
    }

    const renderAutoComplete = (opts) => {
        // if (!opts) return null;
        if (limit !== null && value?.tags?.length >= limit) return null;
        return (
            <Autocomplete
                width="100%"
                label={inputLabel}
                options={tagDifference()}
                optionLabelKey="name"
                onChange={handleAddTag}
                value={search}
                type="text"
                helperText={helperText}
                renderOption={renderSuggestion}
            />
        )
    }

    return (
        <SmartContainer width="100%">

            <SmartContainer width="100%">
                {!noLabels && (
                    <SmartContainer>
                        <StyledP><StyledB>{label}</StyledB></StyledP>
                        {helper && (<StyledP light>{helper}</StyledP>)}
                    </SmartContainer>
                )}

                <HorizontalStack width="100%">{renderTags(value)}</HorizontalStack>
                {renderAutoComplete(options)}
            </SmartContainer>
        </SmartContainer>
    )
}